import React from "react";

const BasicQuote = ({ fill, className }) => (
	<svg
		width="31" 
		height="24" 
		viewBox="0 0 31 24" 
		fill='none'
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path 
			d="M9.834 0.873416C10.582 0.389414 11.264 0.499414 11.88 1.20341C12.496 1.86341 12.496 2.50141 11.88 3.11741C10.516 4.48141 9.57 5.53742 9.042 6.28542C8.514 7.03341 8.206 7.84741 8.118 8.72742C8.03 9.69541 8.316 10.1794 8.976 10.1794C10.296 10.1794 11.418 10.7734 12.342 11.9614C13.266 13.1054 13.728 14.5794 13.728 16.3834C13.728 18.4954 13.112 20.1894 11.88 21.4654C10.692 22.7414 9.086 23.3794 7.062 23.3794C5.126 23.3794 3.454 22.6754 2.046 21.2674C0.682 19.8154 0 17.8574 0 15.3934C0 9.67342 3.278 4.83342 9.834 0.873416ZM26.202 0.873416C26.95 0.389414 27.632 0.499414 28.248 1.20341C28.864 1.86341 28.864 2.50141 28.248 3.11741C26.884 4.48141 25.938 5.53742 25.41 6.28542C24.882 7.03341 24.574 7.84741 24.486 8.72742C24.398 9.69541 24.684 10.1794 25.344 10.1794C26.664 10.1794 27.786 10.7734 28.71 11.9614C29.634 13.1054 30.096 14.5794 30.096 16.3834C30.096 18.4954 29.48 20.1894 28.248 21.4654C27.06 22.7414 25.454 23.3794 23.43 23.3794C21.494 23.3794 19.822 22.6754 18.414 21.2674C17.05 19.8154 16.368 17.8574 16.368 15.3934C16.368 9.67342 19.646 4.83342 26.202 0.873416Z" 
			fill={fill}
		/>
	</svg>



);

export default BasicQuote;
